import React from 'react';
import DialogModal from 'tradera/components/dialog/dialog-modal';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import styles from './similar-sellers-suggestions-modal.module.scss';
import SimilarSellersSuggestionsSeller from './similar-sellers-suggestions-seller';
import { useTranslator } from 'tradera/lang/translate';

const SimilarSellersSuggestionsModal = ({
    onCloseAction,
    suggestedSellers
}) => {
    const { t } = useTranslator();

    return (
        <DialogModal
            className={`overflow-auto w-100  ${styles.similarSellersModal}`}
            mobileFullscreen={false}>
            <div className="d-flex flex-column h-100 w-100">
                <div className="p-2 d-flex align-items-center justify-content-center position-relative border-bottom">
                    <h4 className="mb-0 text-styled">
                        {t('similarSellersSuggestions_title')}
                    </h4>
                    <div className="px-1 w-100 h-100 p-md-1 position-absolute d-flex justify-content-end align-items-center">
                        <button
                            className="btn btn-round z-modal"
                            onClick={() => onCloseAction()}>
                            <CloseIcon className="icon icon-sm" />
                        </button>
                    </div>
                </div>
                <div className={`p-3 ${styles.similarSellersList}`}>
                    {suggestedSellers.map((x) => (
                        <SimilarSellersSuggestionsSeller
                            seller={x}
                            key={x.sellerId}
                        />
                    ))}
                </div>
            </div>
        </DialogModal>
    );
};
export default SimilarSellersSuggestionsModal;
